import React, { useEffect } from "react";
import {
  InputAdornment,
  Button,
  Box,
  Grid,
  TextField,
} from "@material-ui/core";
import { toast } from "react-toastify";
import { Controller, useForm } from "react-hook-form";

const defaultFormValues = {
  name: "",
  address: "",
};

function SenderSettings(props) {
  const { classes, setLoading, disabled, getConfigApi, saveConfigApi } = props;
  const [defaultValues, setDefaultValues] = React.useState(defaultFormValues);
  const { control, handleSubmit, reset } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
  });

  const getSenderInfo = async () => {
    setLoading(true);
    try {
      const result = await getConfigApi();
      setDefaultValues(result.data);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      await saveConfigApi(values);
      toast.dark("Your changes is saved.");
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    getSenderInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    reset(defaultValues);
  }, [defaultValues]);

  return (
    <Grid
      container
      xs={12}
      md={8}
      style={{ marginLeft: "20px", marginTop: "45px" }}
    >
      <form style={{ width: "80%" }}>
        <fieldset disabled={disabled} className="fieldset">
          <Box display="flex" flexDirection="column" className={classes.root}>
            <Controller
              name="name"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  margin="dense"
                  variant="outlined"
                  error={!!error}
                  label="Sender Name"
                  defaultValue={field.name}
                  helperText={
                    error
                      ? error.message
                      : "The name is how it displayed in your contacts' inboxes."
                  }
                  {...field}
                />
              )}
              rules={{ required: "Name required" }}
            />
            <Controller
              name="address"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  margin="dense"
                  variant="outlined"
                  error={!!error}
                  label="Sender Address"
                  defaultValue={field.address}
                  helperText={
                    error
                      ? error.message
                      : "The sender address your contacts will see."
                  }
                  {...field}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        @HKIFF.org.hk
                      </InputAdornment>
                    ),
                  }}
                />
              )}
              rules={{ required: "Address required" }}
            />
          </Box>
          <Grid xs={6} md={4} lg={4}>
            {disabled || (
              <Button
                className={classes.button}
                type="button"
                variant="contained"
                color="primary"
                onClick={handleSubmit(onSubmit)}
              >
                Save Changes
              </Button>
            )}
          </Grid>
        </fieldset>
      </form>
    </Grid>
  );
}

export default SenderSettings;
